module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teaserMobile"
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "bodyContent"
  }, [(_vm.teaserObject) ? _c('div', {
    staticClass: "smallcontainer"
  }, [_c('div', {
    staticClass: "headsmall"
  }, [_c('img', {
    staticClass: "logosl",
    attrs: {
      "src": require("../assets/coloredlogotone.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/mytone')
      }
    }
  }, [_c('img', {
    staticClass: "topbtn",
    attrs: {
      "src": require("../assets/TONE_HOME_ICON.png")
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "grad",
    attrs: {
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/0a3d90ee-c79e-472c-9bae-1a89539be47c.jpg"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("Hey there, " + _vm._s(_vm.teaserObject.firstName))]), _vm._v(" "), _c('p', [_vm._v("Here are your TONE Teasers - videos selected just for you and personalized to your interests.")]), _vm._v(" "), _c('a', {
    staticClass: "lglink",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.teaserObject.video1UrlKey)
      }
    }
  }, [_vm._v(_vm._s(_vm.teaserObject.video1Key))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.teaserObject.video1UrlKey)
      }
    }
  }, [_c('img', {
    staticClass: "video",
    attrs: {
      "src": _vm.teaserObject.video1ImgKey
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "lglink",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.teaserObject.video2UrlKey)
      }
    }
  }, [_vm._v(_vm._s(_vm.teaserObject.video2Key))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.teaserObject.video2UrlKey)
      }
    }
  }, [_c('img', {
    staticClass: "video",
    attrs: {
      "src": _vm.teaserObject.video2ImgKey
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.teaserObject.talkTitle || _vm.teaserObject.expertName) ? _c('div', {
    staticClass: "purpletextcontainer"
  }, [_c('br'), _vm._v(" "), _c('img', {
    staticClass: "blowhorn",
    attrs: {
      "src": "https://s3.amazonaws.com/tone-assets/images/templates/weekly-emails/img_mic.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.teaserObject.quotesValue))]), _vm._v(" "), _c('a', [_vm._v(" - " + _vm._s(_vm.teaserObject.authorNameValue))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.teaserObject.talkTitle || _vm.teaserObject.expertName) ? _c('h3', [_vm._v("Upcoming Events")]) : _vm._e(), _vm._v(" "), (_vm.teaserObject.talkTitle) ? _c('div', {
    staticClass: "entryholder"
  }, [_c('img', {
    attrs: {
      "src": _vm.teaserObject.talkImgUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Tone Talk:" + _vm._s(_vm.teaserObject.talkTitle))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.teaserObject.talkLongDescription)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.teaserObject.talkStartDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(("/event/" + (_vm.teaserObject.talkEventId)))
      }
    }
  }, [_vm._v("Add to Calendar")])]) : _vm._e(), _vm._v(" "), (_vm.teaserObject.expertName) ? _c('div', {
    staticClass: "entryholder"
  }, [_c('img', {
    attrs: {
      "src": _vm.teaserObject.eventImgUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Tone Live: " + _vm._s(_vm.teaserObject.expertName))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.teaserObject.eventLongDescription)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.teaserObject.eventStartDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(("/event/" + (_vm.teaserObject.eventEventId)))
      }
    }
  }, [_vm._v("Add to Calendar")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "advertimg",
    attrs: {
      "src": _vm.teaserObject.funniesValue
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graylastext"
  }, [_vm._v("\n                In the mood of something else?\n            ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/mytone')
      }
    }
  }, [_c('img', {
    staticClass: "topbtn lastlogobutton",
    attrs: {
      "src": require("../assets/TONE_HOME_ICON.png")
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "pinktext"
  }, [_vm._v("Set the tone of your life")]), _vm._v(" "), _c('p', {
    staticClass: "lastpara"
  }, [_vm._v("- The TONE Team")])]) : _vm._e()])])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18b4b22c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/TeaserMobile.vue